module.exports = __webpack_public_path__ + "static/media/nick_with_fans.c39657a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/nick_with_fans.jpg
// module id = 267
// module chunks = 0